export default __webpack_public_path__ + "static/media/_hoshizaki.4b6352aa.png";